import React from 'react';

const ChevronRightIcon = () => {
  return (
    <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 0.800194L6.6 6.00019L1 11.2002" stroke="#227979" strokeLinecap="square" />
    </svg>
  );
};

export default ChevronRightIcon;